export const ITEMS_PER_PAGE = 16

export const SORT_OPTIONS = [
  { value: 'releaseYear-desc', label: 'Najnowsze' },
  { value: 'releaseYear-asc', label: 'Najstarsze' },
]

export const SORT_QUERY_VALUES = {
  pl: {
    'releaseYear-desc': 'najnowsze',
    'releaseYear-asc': 'najstarsze',
  },
  en: {
    'releaseYear-desc': 'newest',
    'releaseYear-asc': 'oldest',
  },
}

// „Najnowsze" i „Najstarsze" to kolejność chronologiczna, a nie ręczne `ord` z panelu, które bywa
// rozjechane (np. po imporcie archiwum). Numery z tego samego roku rozstrzyga data publikacji.
export const buildIssuesOrderFilters = (order) => {
  const direction = order === 'asc' ? 'asc' : 'desc'

  return {
    'order[releaseYear]': direction,
    'order[publishedAt]': direction,
  }
}

export const TABS = [
  { id: 'latest', label: 'Najnowsze' },
  { id: 'archived', label: 'Archiwalne' },
]

export const TAB_QUERY_VALUES = {
  pl: {
    latest: 'biezace',
    archived: 'archiwalne',
  },
  en: {
    latest: 'latest',
    archived: 'archived',
  },
}

export const FILTER_SCHEMA = [
  {
    type: 'filter',
    id: 'numberVolume',
    label: 'Numer / Tom',
    control: 'single',
    allowEmptyOptions: true,
    defaultValue: '',
  },
  {
    type: 'filter',
    id: 'releaseYearFrom',
    label: 'Rok wydania od',
    control: 'single',
    defaultValue: '',
  },
  {
    type: 'filter',
    id: 'releaseYearTo',
    label: 'Rok wydania do',
    control: 'single',
    defaultValue: '',
  },
  {
    type: 'filter',
    id: 'doi',
    label: 'Numer DOI',
    control: 'text',
    defaultValue: '',
  },
  {
    type: 'filter',
    id: 'special',
    label: 'Pokaż tylko numery specjalne',
    control: 'toggle',
    defaultValue: false,
  },
]
